import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import dayjs from "dayjs";
import { DATE_FORMAT } from "@/config/Common.ts";
import { Nullable, Undef } from "@/type/Common.ts";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatPhoneNumber(value: string) {
    const number = value.replace(/[^\d]/g, "");
    if (number.length <= 3) return number;
    if (number.length <= 7) return `${number.slice(0, 3)}-${number.slice(3)}`;
    return `${number.slice(0, 3)}-${number.slice(3, 7)}-${number.slice(7, 11)}`;
}

/**
 * 전화번호 형식 검사
 * */
export const validatePhoneNumber = (value: string): boolean => {
    if (!value) {
        return true;
    }

    const numericValue = value.replace(/[^0-9]/g, "");
    return /^01[016789](\d{3,4})(\d{4})$/.test(numericValue);
};

/**
 * 날짜 형식
 * */
export const dateToString = (date: Date | undefined) => {
    if (!date) return "";
    return dayjs(date).format(DATE_FORMAT);
};

/**
 * 날짜 형식
 * */
export const stringToDate = (date?: Nullable): Undef<Date> => {
    if (!date) return undefined;

    return dayjs(date, DATE_FORMAT).toDate();
};
